<template>
    <div>
        <div class="poup-n"></div>
        <div class="poup-s">
            <img class="img1" src="../../../assets/img/duanwu.png" @click="linkto()" alt="">
            <img class="img2" src="../../../assets/img/del.png"    @click="delClick()">
        </div>
    </div>
</template>
<script>
import { getDBFUrl,updateTuDraBoatFesDialogClickedRecord ,insertTuDraBoatFesRecord} from '@/api/festivalApi'

export default {
    name:'index',
    props:{
        RecordId:Number
    },
    data(){
        return{
            url:'',
        }
    },
    methods:{
        getDBFUrl(){
            getDBFUrl().then(res=>{
           
                this.url=res.data.Body.data
            })
        },
        updateDialog(num){
            return new Promise((resolve,reject)=>{
                updateTuDraBoatFesDialogClickedRecord(num).then(res=>{
                   
                    resolve(res)
                })
            })
            
        },
        //插入埋点数据
        insetData(BannerId,endType,clickType){
            insertTuDraBoatFesRecord(BannerId,endType,clickType).then(res=>{
          
            })
        },
        linkto(){
            // this.$router.push({ path: `/trainingkitDetails/397` })
            window.open(this.url)
            this.$emit('delClick',false)
           this.updateDialog(0).then(res=>{
               this.insetData(0,1,0)
           })
            // window.location.href="https://tutor.acadsoc.ph/trainingkitDetails/397"
        },
        delClick(){
            this.$emit('delClick',false)
            this.updateDialog(1)
        }
    },
    mounted(){
        this.getDBFUrl()
    }
}
</script>
<style lang="scss" scoped>
.poup-n {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0px;
    background: rgba(24, 35, 61, 0.5);
    z-index:99
}
.poup-s{
    position: fixed;
    top: 50%;
    left: 50%;
    margin-top: -234px;
    margin-left: -330px;
    border-radius: 10px;
    z-index: 99;

.img1{
        display: inline-block;
        width: 660px;
        height: 468px;
        border-radius: 10px;
        position: relative;
    }
    .img2{
        position: absolute;
        right: 0;
        top: 0;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        margin-right: -22px;
        margin-top: -20px;
        cursor: pointer;
    }
}
</style>